import 'animate.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useLocation } from 'react-router-dom';
import '../../../ReusableComponent/CIVIL/CivilTestToggle/Toggle.css';

function NeetAllSubjectsTestList({ subject, tests, enrolled, onTakeTest }) {
    const location = useLocation();

    if (subject === 'Please select subject') {
        return (
            <div className='card p-3 my-4 mx-2 shadow-sm border-0 bg-light'>
                <h5 className='text-center m-0 text-muted italic'>
                    Please select a subject and test count in the sidebar to load your tests.
                </h5>
            </div>
        );
    }

    if (!tests || tests.length === 0) {
        return (
            <div className='card p-3 my-4 mx-2 shadow-sm border-0 bg-light'>
                <h5 className='text-center m-0 text-danger fw-bold'>
                    No tests found for the selected plan.
                </h5>
            </div>
        );
    }

    return (
        <>
            <div className='card p-2 my-4 mx-2 shadow-lg'>
                {tests?.map((_, index) => (
                    <div key={index} className="d-grid gap-1 m-1 test-togglebackground">
                        <div className="toggle-button py-2 d-flex justify-content-between align-items-center">
                            <div className="text-nowrap me-2">
                                Test-{index + 1}
                            </div>
                            <div className='me-3 mt-0'>
                                <h1 className='fs-6 mb-0'>{subject}</h1>
                            </div>
                            <div className='me-3 mt-0'>
                                {enrolled ? (
                                    <Link 
                                        to='/StudentDashboard' 
                                        state={{ prePath: location.pathname }} 
                                        className="list-group-item p-1 fw-bold bg-pureorange test-btn text-white text-decoration-none text-center"
                                    >
                                        TAKE TEST
                                    </Link>
                                ) : (
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (typeof onTakeTest === 'function') {
                                                onTakeTest();
                                            }
                                        }}
                                        className="list-group-item p-1 fw-bold bg-pureorange test-btn text-white border-0 text-center"
                                    >
                                        TAKE TEST
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export default NeetAllSubjectsTestList;
